export default __webpack_public_path__ + "static/media/icons8-love-time-100.3cdb0700.svg";